import { forwardRef } from "react";

import { cn } from "@/ui/lib/utils";
import {
  CALLOUT_DEFAULTS,
  CALLOUT_VARIANT_CLASS_MAP,
  type TCalloutProps,
} from "./Callout.config";
import { CalloutAsset } from "./CalloutAsset";
import { CalloutBody } from "./CalloutBody";
import { CalloutTitle } from "./CalloutTitle";
import { CalloutWrapper } from "./CalloutWrapper";

export const Callout = forwardRef<HTMLDivElement, TCalloutProps>(
  (
    {
      title,
      asset,
      children,
      className,
      variant = CALLOUT_DEFAULTS.variant,
      orientation = CALLOUT_DEFAULTS.orientation,
      ...props
    },
    ref,
  ) => (
    <CalloutWrapper
      {...props}
      ref={ref}
      asset={asset}
      className={cn(CALLOUT_VARIANT_CLASS_MAP[variant], className)}
      data-component="Callout"
      orientation={orientation}
    >
      <CalloutAsset asset={asset} />
      <CalloutTitle asset={asset} orientation={orientation} title={title} />
      <CalloutBody asset={asset} orientation={orientation}>
        { children }
      </CalloutBody>
    </CalloutWrapper>
  ),
);

Callout.displayName = "Callout";
